import React from 'react'

const defaultIsSameValue = (a, b) => a === b
const noop = () => {}

const useControlledInput = ({ name, value, onChange = noop, controlled, isSameValue = defaultIsSameValue }) => {
  const [state, setState] = React.useState(value)

  const onInputChange = React.useCallback((nextValue) => {
    if (controlled) {
      onChange(name, nextValue)
    } else {
      setState(nextValue)
      onChange(name, nextValue)
    }
  }, [controlled, name, onChange])

  React.useEffect(() => {
    // In controlled mode, sync props value to state if they're different
    if (controlled && !isSameValue(state, value)) {
      setState(value)
    }
  }, [controlled, state, value, setState, isSameValue])

  return [state, onInputChange]
}

export default useControlledInput
